import { VERSION_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export const ROUTE_PATH = getSectionUrl(VERSION_SECTION);

export const FEATURE_NAME = 'appVersionPage';
